import React, { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import SvgInfo from '@app/components/icons/SvgInfo';
import { theme } from '@app/theme';
import { normalize } from '@app/helpers';

interface InfoBulleProps {
  texte: string;
  testID?: string;
}

/**
 * Icône « i » qui ouvre une bulle d'aide : au survol (web) et au tap. Le texte
 * est une vue en position absolue sous l'icône, sans `title=` HTML ni `Modal`.
 */
export const InfoBulle = ({ texte, testID }: InfoBulleProps) => {
  const [ouverte, setOuverte] = useState(false);

  return (
    <View style={styles.conteneur}>
      <Pressable
        testID={testID}
        accessibilityRole="button"
        accessibilityLabel="Aide"
        // `onHoverIn/onHoverOut` n'existent que sur react-native-web.
        {...({ onHoverIn: () => setOuverte(true), onHoverOut: () => setOuverte(false) } as object)}
        onPress={() => setOuverte((v) => !v)}
        style={styles.icone}>
        <SvgInfo />
      </Pressable>

      {ouverte && (
        <View style={styles.bulle} pointerEvents="none">
          <Text style={styles.texte}>{texte}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  conteneur: {
    position: 'relative',
    zIndex: 10,
  },
  icone: {
    width: 20,
    height: 20,
  },
  bulle: {
    position: 'absolute',
    top: 26,
    right: 0,
    width: 280,
    padding: 12,
    borderRadius: 8,
    backgroundColor: theme.colors.satanGray,
    zIndex: 20,
  },
  texte: {
    color: theme.colors.babypowder,
    fontSize: normalize(14),
    lineHeight: normalize(20),
  },
});
